import apiInstance from "../api";
import { getResFromJWTToken } from "../utils/decodeJWTRes";

const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID ?? "rzp_test_j8b0UbY5OYBXSc";

export const handlePayment = async ({ amount, currency, notes }: any) => {
  try {
    const res = await apiInstance.post(`/order`, {
      amount,
      currency,
      notes,
    });

    if (!res.data || res.status !== 200) {
      throw new Error(res.data?.error || "Failed to create order");
    }

    return getResFromJWTToken(res.data);
  } catch (error) {
    console.error("Payment Error:", error);
    throw error;
  }
};

export const handlePaymentVerify = async (data: any) => {
  const options = {
    key: RAZORPAY_KEY_ID,
    amount: data.amount,
    currency: data.currency,
    name: "codewithharshad",
    description: "Test Mode",
    order_id: data.id,
    image: "https://cdn.pixabay.com/photo/2013/07/13/14/02/star-161984_640.png",
    prefill: {
      name: "codewithharshad",
      email: "zrRZ7@example.com",
      contact: "9999999999",
    },
    notes: {
      address: "Razorpay Corporate Office",
    },
    handler: async (response: any) => {
      try {
        const res = await fetch(`payment/verify`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          }),
        });

        const verifyData = await res.json();
        if (verifyData.message) {
          return verifyData.message; // Return message for the component to handle
        }
      } catch (error) {
        console.error("Verification Error:", error);
        throw error; // Rethrow for handling
      }
    },
    theme: {
      color: "#5f63b8",
    },
  };

  const rzp1 = new window.Razorpay(options);
  rzp1.open();
};
